import React,{useEffect,useState} from "react";
import QuoteBox from '../components/QuoteBox.jsx';
import {HashLink as Link} from 'react-router-hash-link';
import queryString from "query-string";
import {useLocation } from "react-router-dom";
import {useShoeByID} from '../hooks/useShoeByID.js';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as MetricActions from '../actions/Actions.js';
import Helper from '../functions/Helper.js';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomPagination from '../components/CustomPagination';
import Spinner from "react-bootstrap/Spinner";
import UserReviewPopup from "../components/UserReviewPopup.js";


function UserReviews(props){
  const location =useLocation();
  const [userReviews,setUserReviews]=useState([]);
  const [loading,setLoading]=useState("FETCHING");
  const [pickedUserReview,setPickedUserReview]=useState(false);

  //const [shoe,setShoe]=useState(null);
  let queryParams=queryString.parse(location.search);
  let pageIndex=Number(queryParams.pg ?? 1);
  let shoe=useShoeByID(queryParams.shoe_id ?? null,props.currentShoe,props.data,props.actions.shoeData);
  let userHisto=shoe?.user_histo?.rating;

  useEffect(()=>{

    if(queryParams.shoe_id ?? false){
      setLoading("FETCHING");
      setUserReviews([]);
      (async()=>{
        let response = await fetch(__server__+"/API/pub/user_reviews_by_shoe/" + queryParams.shoe_id + "?limit=10&offset=" + (pageIndex -1) *10 ,{
          method: 'GET'
        });
        let data = await response.json();
        setLoading("LOADED");
        setUserReviews(data);
      })()
    }
  },[pageIndex]);


  return(
    shoe &&
    <div>
      <UserReviewPopup hide={()=>setPickedUserReview(false)} review={pickedUserReview}/>
        <div>
          <p style={{marginBottom:10,marginTop:10,}} id="breadcrumbs_react" >
            <span><Link to={"/shoe-reviews/"}>Basketball Shoes</Link> &nbsp;/&nbsp;
              <span><Link to={"/shoe-reviews/" + shoe.url}>{shoe.shoe_name}</Link> &nbsp;/&nbsp;
              <span className="breadcrumb_last">User Reviews</span>
            </span>
          </span>
          </p>
        </div>

        <h1 className="thg_h1_size" style={{marginBottom:30}}>
          User Reviews of the {shoe.shoe_name}
        </h1>

      <div style={{marginBottom:15,fontSize:16}}>Average User Rating:&nbsp;
        <span style={{fontSize:18,fontWeight:"700",color:Helper.get_color(shoe["user_rating"],"text")}}>
          {Helper.printRating(shoe["user_rating"])}
        </span>
        &nbsp;
        <span style={{}}>(ranks <Link style={{fontWeight:"600"}} to={"/shoe-reviews/?order=desc&sortBy=user_rating"}>#{shoe.ranking["user_rating"]} of {props.overview.length}</Link>)</span>
      </div>
      <div style={{marginBottom:20}}>
        {userHisto.map((row,index)=>
          <div key={index} style={{display:"flex",marginBottom:5}}>
            <div style={{flexBasis:100,fontSize:14}}>
              {row.label}
            </div>
            <div style={{flexBasis:200}}>
              <div style={{width:"100%",height:20,backgroundColor: "rgb(239, 239, 239)"}}>
                <OverlayTrigger placement="bottom" overlay={
                    <Tooltip  style={{fontSize:14}} id="tooltip">
                      {row.count +" ratings " +row.description}
                    </Tooltip>
                  }>
                <div style={{backgroundColor:"orange",height:20,width:(row.count / shoe.user_review_amount) *100 +"%"}}></div>
                </OverlayTrigger>
              </div>

            </div>
            <div style={{textAlign:"right",flexBasis:36,fontSize:14}}>
              {row.count}
            </div>
          </div>
        )}
      </div>


      <Button style={{marginBottom:40,fontSize:14}} size="sm" onClick={()=>props.history.push("/shoe-reviews/rating?shoe_id=" + shoe.shoe_id)} variant="outline-dark">Add Your Review</Button>

        {loading==="FETCHING" &&
          <div style={{paddingTop:25}}>
            <Spinner size="sm" animation="border" variant="primary"/>
          </div>
        }

      <div style={{marginTop:20}}>
        {userReviews.map((review,index)=>{
          return(
            <div key={review.user_review_id}>
              <QuoteBox pickReview={()=>setPickedUserReview({...review})}  openStylePopup={()=>{}} by="user" {...review}  category={"overall"}/>
            </div>
            );
          })
        }
      </div>

      <CustomPagination
        getPaginationLink={(x)=>
          location.pathname  + "?" + queryString.stringify({...queryParams,pg:x})
        }
        pages={Helper.getPageArray(shoe.user_review_amount,10)}
        pageIndex={pageIndex}
        />
    </div>
  );
}

export default connect(state => ({...state.data,...state.persistData}), (dispatch) => ({
  actions: bindActionCreators(MetricActions, dispatch)
}))(UserReviews);
